import styled from 'styled-components';

export const ActionItemButton = styled.button<{ color: string }>`
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 0;
  margin: 0;

  color: ${({ color }) => color};
  font-size: 0.875rem;
  font-weight: 500;
  line-height: 18px;
  text-align: center;

  background: none;
  border: none;
  outline: none;
  border-radius: 6px;

  transition:
    opacity 250ms ease,
    background-color 250ms ease;

  &:hover {
    opacity: 0.8;
  }
  &:active {
    background-color: #f9f9f9;
  }

  svg {
    width: 24px;
    height: 24px;
    margin-bottom: 6px;
  }
`;
